/**
 * Box Component
 *
 * Abstraction layer over MUI Box.
 * The most commonly used layout component.
 */

import { BoxProps, Box as MuiBox } from '@mui/material';
import React from 'react';

const Box = React.forwardRef<any, BoxProps<any, any>>((props: any, ref) => {
  return <MuiBox ref={ref} {...props} />;
});

Box.displayName = 'Box';

export default Box;
